// jQuery
import './utils/jquery';
import $ from 'jquery';
import $script from 'scriptjs';

// Shared Components
import ShopifySectionsManager from 'shopify-sections-manager';
import 'intersection-observer/intersection-observer';
import rimg from 'rimg-shopify';
import PxsMap from 'pxs-map';

// Utils
import Rte from './utils/Rte';
import ThemeUtils from './utils/ThemeUtils';

// Templates
import TemplateAccount from './templates/TemplateAccount';
import TemplateCollection from './templates/TemplateCollection';
import TemplateGiftCard from './templates/TemplateGiftCard';
import TemplateListCollections from './templates/TemplateListCollections';
import TemplatePassword from './templates/TemplatePassword';

// Sections
import DynamicFeaturedCollections from './sections/DynamicFeaturedCollections';
import DynamicFeaturedImages from './sections/DynamicFeaturedImages';
import DynamicFeaturedProducts from './sections/DynamicFeaturedProducts';
import DynamicSlideshow from './sections/DynamicSlideshow';
import DynamicVideo from './sections/DynamicVideo';
import StaticCart from './sections/StaticCart';
import StaticProduct from './sections/StaticProduct';

// Components
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';

const scripts = $('[data-scripts]');

class Pacific {
  constructor() {
    window.ThemeUtils = ThemeUtils;
    const body = $(document.body);
    this.$el = body;
    // Set up conditionals
    this.isHome = body.hasClass('template-index');
    this.isCollection = body.hasClass('template-collection');
    this.isListCollections = body.hasClass('template-list-collections');
    this.isProduct = body.hasClass('template-product');
    this.isCart = body.hasClass('template-cart');
    this.isPage = body.hasClass('template-page');
    this.isPassword = body.hasClass('template-password');
    this.isGiftCardPage = body.hasClass('gift-card-template');
    this.isAccount = body.attr('class').indexOf('-customers-') > 0;
    this.render();
  }

  render() {
    // Common views
    this.sections = new ShopifySectionsManager();

    this.sections.register('header', section => new Header(section));
    this.sections.register('footer', section => new Footer(section));
    this.sections.register('slideshow', section => new DynamicSlideshow(section));
    this.sections.register('collection-list', section => new DynamicFeaturedCollections(section));
    this.sections.register('featured-collection', section => new DynamicFeaturedProducts(section));
    this.sections.register('featured-video', section => new DynamicVideo(section));
    this.sections.register('pxs-map', section => new PxsMap(section));
    this.sections.register('featured-images', section => new DynamicFeaturedImages(section));

    this.sections.register('featured-product', section => new StaticProduct(section));
    this.sections.register('page-product', section => new StaticProduct(section));

    $('.rte').each((index, rte) => { new Rte({ el: rte }); });

    if (window.Pacific.settings['enable-sidebar']) { new Sidebar({ el: $('.sidebar') }); }

    // Conditional views
    if (this.isCollection) { new TemplateCollection({ el: this.$el }); }

    if (this.isListCollections) { new TemplateListCollections({ el: $('.collections-list') }); }

    if (this.isCart) { new StaticCart({ el: this.$el }); }

    if (this.isAccount) { new TemplateAccount({ el: this.$el }); }

    if (this.isPassword) { new TemplatePassword({ el: this.$el }); }

    if (this.isGiftCardPage) { new TemplateGiftCard(); }

    rimg.init();
  }
}

$script([
  scripts.data('countries-url'),
  scripts.data('shopify-currencies-url'),
  scripts.data('customer-area-url'),
  scripts.data('shopify-api-url'),
  scripts.data('jquery-templates-url'),
  scripts.data('shopify-common-url'),
],
() => {
  $script([
    scripts.data('jquery-cart-url'),
    scripts.data('jquery-currencies-url'),
  ],
  () => {
    new Pacific();
  });
});
